import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAltSlash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Select from "react-select";

import styles from "../styles/style.module.css";
import commonStyles from "../../../lib/common/common.module.css";
import { APP_ROUTES, LOCAL_CONSTANTS } from "../../../lib/constants";
import { UserTypes } from "../../../interfaces";
import { list, update } from "../api";
import Layout from "../../../ui/layout";
import { IMAGES } from "../../../assets/images";
import { DropDownMenu, ActionButton, Pagination, Popup } from "../../../ui";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import SelectColumns from "../../../ui/Popup/selectColumn";
import { getRole } from "../../../lib/common/common";

const Customers = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // useEffect(() => {   
  //   const roles: any = window.localStorage.getItem("admin_roles")
  //   if (roles == 4 || roles == 5) return navigate(APP_ROUTES.PARTNERS);
  // },[])
  const [pagination, setPagination] = useState({
    skip: 0,
    limit: LOCAL_CONSTANTS.limitCount,
  });
  const [search, setSearch] = useState < string | null > (null);
  const [order, setSortOrder] = useState < number > (0);
  const [sortBy, setSortColumn] = useState < string > ("");
  const [blockedAccounts, setBlockedAccounts] = useState < boolean | null > (null);
  const [verifiedEmailAccount, setVerifiedEmailAccounts] = useState < boolean | null > (null);
  const [verifiedPhoneNoAccount, setVerifiedPhoneNoAccounts] = useState < boolean | null > (null);
  const [startDate, setStartDate] = useState < string > ("");
  const [endDate, setEndDate] = useState < string > ("");
  const [show, setShow] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState < any[] > (LOCAL_CONSTANTS.CustomersTableHeaders.slice(0, 15));
  const [users, setUsers] = useState < { list: any[]; count: number } > ({
    list: [],
    count: 0,
  });

  const [loading, setLoading] = useState < boolean > (true);
  const [dialog, setDialog] = useState({ show: false, id: "", status: false });

  const listUsers = (
    pageIndex = pagination.skip,
    isBlocked: boolean | null = null,
    isPhoneNoVerified: boolean | null = null,
    isEmailVerified: boolean | null = null
  ) => {
    let query: any = {
      page: (1 + pageIndex),
      limit: pagination.limit,
      ...searchObject,
    };

    if (search) {
      query['search'] = search;
    }
    if (startDate) {
      query.startDate = startDate;
    }
    if (endDate) {
      query.endDate = endDate;
    }
    list(query).then(({ data }) => {
      setUsers({
        list: data.data
        , count: data.count
      });
      setLoading(false);
    });
  };
  const handleSelectColumn = () => {
    setShow(true);
  }
  const [searchObject, setSearchObject] = useState({});

  const handleResetFilters = () => {
    setSearchObject({});
    setStartDate("");
    setEndDate("");
    setPagination((prev) => ({ ...prev, skip: 0 }));
  };

  useEffect(() => {
    setLoading(true);
    const debounceSearch = setTimeout(() => {
      listUsers();
    }, 500);
    return () => {
      clearTimeout(debounceSearch);
    };
  }, [pagination, searchObject, startDate, endDate]);

  useEffect(() => {
    console.log(searchObject, "searchObject")
  }, [searchObject]);


  const blockUnblockUser = () => {
    const payload = {
      userId: dialog.id,
      isBlocked: dialog.status,
    };
    toast.promise(
      update(payload),
      {
        pending: {
          render() {
            return LOCAL_CONSTANTS.updatingUser;
          },
        },
        success: {
          render() {
            let tempUser = users.list;
            let index = tempUser.findIndex((item) => item._id === dialog.id);

            tempUser[index].isBlocked = !tempUser[index].isBlocked;

            setUsers({ ...users, list: tempUser });

            setDialog({ show: false, id: "", status: false });
            return dialog.status
              ? LOCAL_CONSTANTS.userBlockedSuccessfully
              : LOCAL_CONSTANTS.userUnblockedSuccessfully;
          },
        },
        error: {
          render() {
            return LOCAL_CONSTANTS.errorOnUpdatingUser;
          },
        },
      });
  };

  const handleSort = (column: string) => {
    setSortColumn(column);
    setSortOrder(
      order === LOCAL_CONSTANTS.descKey
        ? LOCAL_CONSTANTS.ascKey
        : LOCAL_CONSTANTS.descKey
    );
    const query = {
      ...pagination,
      search,
      order:
        order === LOCAL_CONSTANTS.descKey
          ? LOCAL_CONSTANTS.ascKey
          : LOCAL_CONSTANTS.descKey,
      sortBy: column,
    };
    list(query).then(({ data }) => {
      setUsers({
        list: data.data
        , count: data.count
      });
      setLoading(false);
    });
  };


  return (
    <Layout title="Customers">
      <div className={commonStyles.tableData}>
        <div className={commonStyles.topFilter}>
          <div className="d-flex align-items-center flex-wrap" style={{ gap: "14px", rowGap: "12px" }}>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              onClick={(e) => { try { (e.currentTarget as HTMLInputElement).showPicker?.(); } catch {} }}
              min="2000-01-01"
              max="2099-12-31"
              placeholder="Start Date"
              style={{
                height: 40,
                width: 170,
                minWidth: 170,
                padding: "0 10px",
                borderRadius: 4,
                border: "1px solid #333",
                boxSizing: "border-box",
                fontSize: 14,
                lineHeight: "40px",
                colorScheme: "light",
                cursor: "pointer",
              }}
            />
            <input
              type="date"
              value={endDate}
              onChange={(e) => {
                if (startDate && e.target.value < startDate) {
                  toast.error("End date cannot be before start date");
                  return;
                }
                setEndDate(e.target.value);
              }}
              onClick={(e) => { try { (e.currentTarget as HTMLInputElement).showPicker?.(); } catch {} }}
              min="2000-01-01"
              max="2099-12-31"
              placeholder="End Date"
              style={{
                height: 40,
                width: 170,
                minWidth: 170,
                padding: "0 10px",
                borderRadius: 4,
                border: "1px solid #333",
                boxSizing: "border-box",
                fontSize: 14,
                lineHeight: "40px",
                colorScheme: "light",
              }}
            />
            <button
              onClick={handleResetFilters}
              className={styles.loyalityPointBtn}
              style={{ height: 40, padding: "0 28px" }}
            >
              Reset
            </button>
            <button
              onClick={handleSelectColumn}
              className={styles.loyalityPointBtn}
              style={{ height: 40, padding: "0 18px" }}
            >
              Select Columns
            </button>
          </div>
        </div>
        <div className={styles.scrollTable}>
          <table>
            <thead>
              <tr>
                {selectedColumns?.map((header: UserTypes.TableHeader) => (
                  selectedColumns.includes(header) && <th
                    className={`${["fullName", "phoneNumber"].includes(header?.value)
                      ? "cursor-pointer"
                      : ""
                      }`}
                    onClick={() => {
                      if (["fullName", "phoneNumber"].includes(header?.value)) {
                        handleSort(header?.value);
                      }
                    }}
                    key={header?.value}
                  >
                    {header?.label}
                    {/* {sortBy === header?.value &&
                      ["fullName", "phoneNumber"].includes(header?.value) &&
                      renderSortIcon(header?.value)} */}
                    <div className={commonStyles.topFilter}>
                      <div className={styles.date_calender}>
                        {header.label !== "Actions" && !header.label.includes("Date") && header.label !== "Role" && header.label !== "Blocked" && <input

                          onChange={(e) => {
                            setSearchObject({ ...searchObject, [header.value]: e.target.value });
                          }}


                        />}

                      </div>
                      {header.label === "Role" && <div className="w-100">

                        <Select
                          options={LOCAL_CONSTANTS.ZOLVE_ROLES}
                          onChange={(response) => {
                            if (response) {
                              let pageIndex = 0;
                              let status = response.value;

                              setSearchObject({ ...searchObject, [header.value]: response.value });
                              // listUsers(pageIndex, blockedAccounts, verifiedPhoneNoAccount, status);
                            }
                          }}
                          defaultValue={{ value: "", label: "Select Role" }}
                          className="w-100"
                        />
                      </div>}
                      {header.label === "Blocked" && <div className="w-">

                        <Select
                          options={LOCAL_CONSTANTS.blockedAccounts}
                          onChange={(response) => {
                            if (response) {
                              let pageIndex = 0;
                              let status = response.value;

                              setSearchObject({ ...searchObject, [header.value]: response.value });
                              // listUsers(pageIndex, blockedAccounts, verifiedPhoneNoAccount, status);
                            }
                          }}
                          defaultValue={LOCAL_CONSTANTS.blockedAccounts[0]}
                          className="w-100"
                        />
                      </div>}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={7} align="center" className={styles.loadingText}>
                    {LOCAL_CONSTANTS.loading}
                  </td>
                </tr>
              )}
              {!loading && users.list?.length === 0 && (
                <tr>
                  <td colSpan={7} align="center">
                    No User Found
                  </td>
                </tr>
              )}
              {!loading &&
                users.list.map((item) => (
                  <tr>{selectedColumns.map((rr) => {

                    if (rr.value === "Action") {
                      return <td>{"N/A"}</td>;
                    } else if (rr.value === "Passport") {
                      return <td>{item.documents ?
                        <span style={{ cursor: "pointer" }} onClick={() => {
                          window.open(item.documents.passportFront, "_blank");
                        }}>View Passport</span>
                        : "N/A"}</td>;
                    } else if (rr.value === "order Id") {
                      return <td>{item._id}</td>;
                    } else if (rr.value === "Transaction Date") {
                      return <td>{moment.utc(item.createdAt).format("DD/MM/YYYY")}</td>;
                    } else if (rr.value === "ICCID") {
                      return <td>{"N/A"}</td>;
                    } else if (rr.value === "Servicable") {
                      return <td>{"N/A"}</td>;
                    } else if (rr.value === "Shipping Cost") {
                      return <td>{"N/A"}</td>;
                    } else if (rr.value === "WBN") {
                      return <td>{"N/A"}</td>;
                    } else if (rr.value === "Status") {
                      return <td>{"N/A"}</td>;
                    } else if (rr.value === "API Id") {
                      return <td>{"N/A"}</td>;
                    } else if (rr.value === "User Id") {
                      return <td>{item.partnerUserId._id}</td>;
                    } else if (rr.value === "Customer Name") {
                      return <td>{item.partnerUserId.firstName + " " + item.partnerUserId.lastName}</td>;
                    } else if (rr.value === "Phone") {
                      return <td>{item.partnerUserId.phoneNumber}</td>;
                    } else if (rr.value === "Address Line1") {
                      return <td>{item.address.streetAddress},{item.address.city}</td>;
                    } else if (rr.value === "Address Line 2") {
                      return <td>{item.address.streetAddress},{item.address.city}</td>;
                    } else if (rr.value === "City") {
                      return <td>{item.address.city}</td>;
                    } else if (rr.value === "Pincode") {
                      return <td>{item.address.zipCode}</td>;
                    } else if (rr.value === "Dob") {
                      return <td>{"N/A"}</td>;
                    } else if (rr.value === "Travel Date") {
                      return <td>{"N/A"}</td>;
                    } else if (rr.value === "State") {
                      return <td>{item.address.state}</td>;
                    } else if (rr.value === "email") {
                      return <td>{item.partnerUserId.email}</td>;
                    } else if (rr.value === "brand") {
                      return <td>{"N/A"}</td>;
                    }
                  })}</tr>))}
            </tbody>
          </table>
        </div>
        <Pagination
          paginationState={pagination}
          setPaginationState={setPagination}
          count={users.count}
        />
        <Popup
          show={dialog.show}
          handleClose={() => setDialog({ show: false, id: "", status: false })}
          heading={LOCAL_CONSTANTS.areYouSure}
          content={LOCAL_CONSTANTS.areYouSureRestrictUserAccess}
          handleSubmit={blockUnblockUser}
          id={dialog.id}
        />
        <SelectColumns selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} show={show} handleClose={() => setShow(false)} iso="" columns={LOCAL_CONSTANTS.CustomersTableHeaders} />

      </div>
    </Layout>
  );
};

export default Customers;
